export default __webpack_public_path__ + "static/download-play-2522f2577fa1e37f2239dbade6bbfff8.svg";